/* eslint-disable no-use-before-define */
import React from 'react'
import {$, getEventHandlers, getId, } from '../twd'

const Modes = {
    'NONE': 'none',
    'SEARCH': 'search'
}

export default ({
    multiple=true,
    placeholder='',
    onSelect,
    value='',
    type="search",
    disabled=false,
    onBlur,
    onFocus,
    onClear,
    onChange,
    clearOnBlur=true,
    showIcon=true,
    inputConfig,
    listConfig,
    id,
    dataName='twd-fields-search',
    children
} = {}) => {
    const inputRef = React.useRef()
    const resultRef = React.useRef()
    const [keyword, setKeyword] = React.useState(null)
    const [mode, setMode] = React.useState(Modes.NONE)

    var lock = false
    const onFocus_ = (e) => {
        if (onFocus) onFocus(e)
        onChange_(e)
    }

    const onClear_ = () => {
        lock = true
        let e = inputRef.current
        e.value = ''
        e.placeholder = ''
        e.focus()
        if (onClear) onClear()
    }

    const onBlur_ = (e) => {
        setTimeout(() => {
            let el = inputRef.current

            if (el && lock) {
                lock = false
                el.focus()
                return
            }

            if (el && onBlur) {
                let t = onBlur({
                    keyword: keyword,
                    inputEl: el
                })
                if (typeof t === "string") {
                    el.value = t
                }
                else if (t===false) {
                    return
                }
                else if (clearOnBlur) {
                    el.value = ''
                }
            }
            else if (el && clearOnBlur) {
                el.value = ''
            }

            setKeyword('')
            setMode(Modes.NONE)
        }, 250)
    }

    const onChange_ = (e) => {
        let txt = inputRef.current.value
        setKeyword(txt)
        setMode(Modes.SEARCH)
        if (onChange) onChange(txt)
    }

    const select = (itm) => {
        if (!onSelect) return
        let s = onSelect(itm) || ''
        let e = inputRef.current
        e.placeholder = s || placeholder
        e.value = s
        setKeyword(s)
    }

    const onKeyPress = (e) => {
        let key = e.keyCode || e.key || e.which

        let isSelected = key===13 || key==='Enter'
        if (!isSelected) return

        e.preventDefault()

        let el = resultRef.current
        let a = $(el).find('.auto-suggest-menu-item.focus')[0]
        if (a) {
            let i = getEventHandlers(a).item
            if (!i) return

            if (multiple) {
                lock = true
            } else {
                e.target.blur()
            }
            select(i)
            return
        }

        let txt = e.target.value
        if (!txt) return

        if (multiple) {
            lock = true
        } else {
            e.target.blur()
        }
        select(txt)
    }

    const onKeyDown = (e) => {
        if (mode !== Modes.SEARCH) return

        let key = e.keyCode || e.key || e.which

        if (key===9 || key === 27 || key==='Escape') {
            onBlur_()
            return
        }

        if (key === 38 || key==='ArrowUp') {
            let el = resultRef.current
            let a = $(el)
                .find('.auto-suggest-menu-item.focus')
                .removeClass('focus')
                .prevAll('.auto-suggest-menu-item')
                .first()
                .addClass('focus')
            if (a.length>0) return

            $(el).find('.auto-suggest-menu-item')
                .last()
                .addClass('focus')

            return
        }

        if (key === 40 || key==='ArrowDown') {
            let el = resultRef.current

            let a = $(el)
                .find('.auto-suggest-menu-item.focus')
                .removeClass('focus')
                .nextAll('.auto-suggest-menu-item')
                .first()
                .addClass('focus')

            if (a.length>0) return

            $(el).find('.auto-suggest-menu-item')
                .first()
                .addClass('focus')

            return
        }
    }

    const onItemClick = (e) => {
        e.preventDefault()
        do {
            let el = $(e.target)
            let a = (el.hasClass('auto-suggest-menu-item') && el[0])
                || el.parents('.auto-suggest-menu-item')[0]
            if (!a) break

            let ee = el[0]
            if (ee && ee.nodeName==='INPUT' && 'checked' in ee) {
                setTimeout(() => a.click())
                return
            }

            let i = getEventHandlers(a).item
            if (!i) break

            select(i)

        } while(false)

        if (multiple) lock = true
    }

    const isSearch = type==='search'
    const icon = showIcon ? (isSearch ? 'search' : 'keyboard_arrow_down') : ''
    const iconAlign = showIcon ? (isSearch ? 'icon-left' : 'icon-right') : ''
    const iconStyle = icon==='search' ? {color:'var(--primary-base-color)'} : {}
    const _id = id || getId()

    return (<React.Fragment>
        <div className={ 'form-icon-group ' + iconAlign} style={{overflow:"visible"}}>
            {!disabled && <i
                className="material-icons"
                aria-hidden="true"
                style={Object.assign(isSearch ? {} : {pointerEvents:'all'}, iconStyle)}
                onClick={(e) => {
                    if (mode===Modes.NONE) {
                        onFocus_(e)
                        inputRef.current.focus()
                    } else {
                        setTimeout(() => onBlur_(e))
                    }
                }}
            >{icon}</i>}

            <input
                ref={inputRef}
                type="text"
                className="form-control text-truncate"
                id={_id}
                data-name={dataName + '-input'}
                disabled={disabled}
                aria-disabled={disabled}
                onFocus={onFocus_}
                onBlur={onBlur_}
                onKeyPress={onKeyPress}
                onKeyDown={onKeyDown}
                onChange={onChange_}
                placeholder={placeholder}
                {...inputConfig}
                value={mode===Modes.NONE ? (value || '') : inputRef.current.value}
                >
            </input>

            { isSearch && mode!==Modes.NONE &&  (
                <button
                data-name={dataName + '-clear'}
                type="button"
                onClick={onClear_} style={{
                    position: 'absolute',
                    top: 0,
                    right: '25px',
                    zIndex: 2,
                    cursor:'pointer',
                    background: '0 0',
                    border: 'none'
                }}><i className="material-icons" aria-hidden="true" style={{
                    pointerEvents:'auto'
                }}>clear</i></button>
            )}

            <div aria-live="polite" ref={resultRef}>{
                mode!==Modes.NONE
                && (!isSearch || keyword)
                && children
                && <div
                    data-name={dataName + '-selections'}
                    className="auto-suggest-menu"
                    style={{paddingBottom:'10px'}}
                    onFocus={() => {
                        lock = true
                    }}
                    onMouseDown={() => {
                        return false
                    }}
                    {...listConfig}
                    onClick={onItemClick}>{children({ keyword })}</div>
            }</div>
        </div>
        </React.Fragment>)
}

export const SearchOption = ({
    item,
    children,
    props,
    dataName='twd-fields-search'
} = {}) => {
    return <div
        data-name={dataName + '-option'}
        className="auto-suggest-menu-item text-truncate"
        style={{paddingLeft:'10px'}}
        {...props}
        item={item}>
    {children}
    </div>
}
